import { FC, ReactNode } from "react";

interface DepositStepHeaderProps {
  title: ReactNode;
  description?: ReactNode;
}

export const DepositStepHeader: FC<DepositStepHeaderProps> = ({
  title,
  description,
}) => {
  return (
    <div className="flex w-full flex-col items-center gap-2 text-center">
      <div className="relative flex min-h-8 w-full justify-center">
        <div className="relative inline-flex max-w-[22rem] items-center justify-center self-center sm:max-w-[24rem]">
          <h1 className="whitespace-nowrap text-[clamp(1.375rem,4.2vw,2.25rem)] font-medium text-white">
            {title}
          </h1>
        </div>
      </div>
      {description && (
        <p className="max-w-[22rem] text-sm text-sr-pink-muted sm:max-w-[24rem] sm:text-base">
          {description}
        </p>
      )}
    </div>
  );
};
